import React from 'react'
import { Login } from '../screens'
import { AuthContext } from './AuthContext'

export default function RequireAuth({ children }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  if (sttAuthCtx.isLogged) {
    return children
  } else {
    return <Login />
  }
}
